module.exports = __webpack_public_path__ + "front/img/login-bg.41b5a6f2.png";